import { render, staticRenderFns } from "./TabGeneralInfo.vue?vue&type=template&id=5ced7a4d&scoped=true&"
import script from "./TabGeneralInfo.vue?vue&type=script&lang=js&"
export * from "./TabGeneralInfo.vue?vue&type=script&lang=js&"
import style0 from "./TabGeneralInfo.vue?vue&type=style&index=0&id=5ced7a4d&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../nguonhangchina/admin/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ced7a4d",
  null
  
)

export default component.exports